import { render, staticRenderFns } from "./mobileBindOn.vue?vue&type=template&id=93f88e06&scoped=true"
import script from "./mobileBindOn.vue?vue&type=script&lang=ts"
export * from "./mobileBindOn.vue?vue&type=script&lang=ts"
import style0 from "./mobileBindOn.vue?vue&type=style&index=0&id=93f88e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f88e06",
  null
  
)

export default component.exports